import TireSearch from './TireSearch';

export default TireSearch;
